var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.userFormToUpdate)?_c('user-form',{attrs:{"title":_vm.title,"submit-button-text":_vm.submitButtonText,"user-form-to-update":_vm.userFormToUpdate},on:{"submitUserForm":function($event){return _vm.onSubmit($event)}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }